import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

export const routes = [
  {
    path: '/loginDev',
    component: () => import(/* webpackChunkName: "skl-base" */'../components/loginDev.vue')
  },
  {
    path: '/test',
    component: () => import(/* webpackChunkName: "skl-base" */'../components/test.vue')
  },
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "skl-base" */'../components/login.vue')
  },
  {
    path: '/',
    component: () => import('../components/index.vue'),
    meta: {index: 0},
    children: [
      {
        path: '/call/course',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/call/index.vue'),
        meta: {level: 1, title: '课堂点名', icon: 'course-call', index: 0, keepAlive: true},
        children: []
      },
      {
        path: '/call/detail',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/call/chunk/index.vue'),
        meta: {level: 2, index: 0, keepAlive: true},
        children: []
      },
      {
        path: '/call/detail/list',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/call/detail.vue'),
        meta: {level: 2, index: 0, keepAlive: true},
        children: []
      },
      {
        path: '/call/detail/history',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/call/history.vue'),
        meta: {level: 3, index: 0, keepAlive: true},
        children: []
      },
      {
        path: '/call/detail/total',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/call/total.vue'),
        meta: {level: 3, index: 0, keepAlive: true},
        children: []
      },
      {
        path: '/call/sign',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/call/sign-detail.vue'),
        meta: {level: 2, index: 0, keepAlive: true},
        children: []
      },
      {
        path: '/call/course/detail/:id',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/call/course-detail.vue'),
        meta: {level: 3, index: 0, keepAlive: true},
        children: []
      },
      {
        path: '/call/course/audit/leave',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/leave/courseTeacher.vue'),
        meta: {level: 3, index: 0, keepAlive: true},
        children: []
      },
      {
        path: '/sign/in',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/sign/index.vue'),
        meta: {level: 1, title: '课堂签到', icon: 'sign', index: 1, keepAlive: true},
        children: []
      },
      {
        path: '/sign/in/valid',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/sign/valid.vue'),
        meta: {level: 2, title: '课堂签到', icon: 'sign', index: 1, keepAlive: true, noLeftBtn: true},
        children: []
      },
      {
        path: '/sign/in/rate',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/sign/rate-warp.vue'),
        meta: {level: 3, title: '课堂签到', icon: 'sign', index: 1, keepAlive: true, noLeftBtn: true},
        children: []
      },
      {
        path: '/sign/in/detail',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/sign/complete.vue'),
        meta: {level: 4, title: '课堂签到', icon: 'sign', index: 1, keepAlive: true, noLeftBtn: true},
        children: []
      },
      {
        path: '/check',
        component: () => import(/* webpackChunkName: "group-check" */'../components/check/index.vue'),
        meta: {level: 1, title: '过程考核', icon: 'course-check', index: 2, type: 'check'}
      },
      {
        path: '/check/course',
        component: () => import(/* webpackChunkName: "group-check" */'../components/check/course/index.vue'),
        meta: {level: 2, index: 2, keepAlive: true},
        children: []
      },
      {
        path: '/check/course/detail',
        component: () => import(/* webpackChunkName: "group-check" */'../components/check/course/detail.vue'),
        meta: {level: 3, index: 2, keepAlive: true},
        children: []
      },
      {
        path: '/check/course/detail/set/score',
        component: () => import(/* webpackChunkName: "group-check" */'../components/check/course/set-score-page.vue'),
        meta: {level: 4, index: 2, keepAlive: true},
        children: []
      },
      {
        path: '/setting',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/index.vue'),
        meta: {level: 1, title: '我', icon: 'person', index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/info',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/info/index.vue'),
        meta: {level: 2, index: 3, type: 'setting', keepAlive: true},
        children: []
      },
      {
        path: '/setting/info/changePassword',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/info/changePassword.vue'),
        meta: {level: 2, index: 3, type: 'setting', keepAlive: true},
        children: []
      },
      {
        path: '/setting/percent',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/check/index.vue'),
        meta: {level: 2, index: 3, type: 'setting', keepAlive: true},
        children: []
      },
      {
        path: '/setting/percent/detail',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/percent/detail.vue'),
        meta: {level: 3, index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/records',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/records/index.vue'),
        meta: {level: 2, index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/records/detail',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/records/detail.vue'),
        meta: {level: 3, index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/records/schedule',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/records/schedule.vue'),
        meta: {level: 3, index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/absentWarn',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/absentWarn/index.vue'),
        meta: {level: 2, index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/absentWarn/detail',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/absentWarn/detail.vue'),
        meta: {level: 2, index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/data',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/data/index.vue'),
        meta: {level: 2, index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/top',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/stu-top/index.vue'),
        meta: {level: 3, index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/top/detail/:id',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/stu-top/course-detail.vue'),
        meta: {level: 3, index: 0, keepAlive: true},
        children: []
      },
      {
        path: '/setting/top/my/detail',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/stu-top/course-detail.vue'),
        meta: {level: 3, index: 0, keepAlive: true},
        children: []
      },
      {
        path: '/setting/leave',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/leave/index.vue'),
        meta: {level: 2, index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/leave/add',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/leave/add.vue'),
        meta: {level: 3, index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/leave/help',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/leave/helpList.vue'),
        meta: {level: 3, index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/leave/helpAdd',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/leave/helpAdd.vue'),
        meta: {level: 3, index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/leave/detail/:id',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/leave/audit.vue'),
        meta: {level: 3, index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/courseAdjust',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/courseAdjust/index.vue'),
        meta: {level: 2, index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/courseAdjust/add',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/courseAdjust/add.vue'),
        meta: {level: 3, index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/courseAdjust/detail/:id',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/courseAdjust/detail.vue'),
        meta: {level: 3, index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/courseAdjust/courseList',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/courseAdjust/courseList.vue'),
        meta: {level: 3, index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/courseAdjust/auditList',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/courseAdjust/auditList.vue'),
        meta: {level: 3, index: 3, keepAlive: true},
        children: []
      },
      {
        path: '/setting/courseAdjust/audit/:id',
        component: () => import(/* webpackChunkName: "skl-base" */'../components/setting/courseAdjust/audit.vue'),
        meta: {level: 3, index: 3, keepAlive: true},
        children: []
      }
    ]
  },
  {path: '*', redirect: '/call/course'}
];

const router = new VueRouter({
  mode: 'history',
  routes: routes,
  base: '/'
});

export default router;
